
import {
  defineStore
} from 'pinia'

export const useVariantCollectionStore = defineStore('VariantCollectionStore', {
  state: () => {
    return {
      slideoutOpen: false
    }
  },

  actions: {
    openSlideout () {
      this.slideoutOpen = true
      document.body.classList.add('overflow-hidden')
      // Dispatch custom event when slideout opens
      document.dispatchEvent(new CustomEvent('hidePDPNavigationButtons', {
        detail: { source: 'variant-collection' }
      }))
    },
    closeSlideout (event = null) {
      if (!event || event.target.hasAttribute('data-close')) {
        this.slideoutOpen = false
        document.body.classList.remove('overflow-hidden')
        // Dispatch custom event when slideout closes
        document.dispatchEvent(new CustomEvent('showPDPNavigationButtons', {
          detail: { source: 'variant-collection' }
        }))
      }
    }
  },

  getters: {
  },
})
